module.exports = __webpack_public_path__ + "img/logo_login.c1e48405.png";